export default "__VITE_ASSET__BMG$WDHd__"